var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-category mb-4"},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.categoryList),function(category,index){return _c('li',{key:'cat_' + index,staticClass:"list-group-item m-0 p-0",class:{
        active: index === 0,
      },on:{"click":function($event){return _vm.handleClick(category)}}},[_vm._v(" "+_vm._s(category)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }